import parseUri from './parseUri'

function parseRedirectUriFromQueryString(queryString) {
  const redirectUri = new URLSearchParams(queryString).get('redirect_uri')
  return parseUri(redirectUri)
}

export default parseRedirectUriFromQueryString
